// The endpoint expresses eligible methods either as a plain list
// (`payment_methods`) or as a map keyed by method name
// (`payment_method_configurations`). Normalize both into a string list,
// validating the shape so an unexpected payload can't break `.every` downstream.
const extractEligibleMethods = (data) => {
    const methods = data === null || data === void 0 ? void 0 : data.payment_methods;
    if (Array.isArray(methods)) {
        return methods;
    }
    const configurations = data === null || data === void 0 ? void 0 : data.payment_method_configurations;
    if (configurations && typeof configurations === 'object') {
        return Object.keys(configurations);
    }
    return [];
};
export default class PaymentMethodSettings {
    constructor(raw = {}) {
        var _a;
        Object.defineProperty(this, "eligibleMethods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.success = (_a = raw === null || raw === void 0 ? void 0 : raw.success) !== null && _a !== void 0 ? _a : false;
        this.eligibleMethods = extractEligibleMethods(raw === null || raw === void 0 ? void 0 : raw.data);
    }
}
